import { useLayout } from 'stores/LayoutStore'
import Styles from './Viewport.module.scss'

export const Viewport = () => {
  const layout = useLayout()
  return <div ref={(node) => layout.setViewport(node)} className={Styles.container} />
}
